export const PROFILE_PIC_URL_PREFIX = 'https://ak-static.cms.nba.com/wp-content/uploads/headshots/nba/latest/260x190';
export const TEAM_PIC_URL_PREFIX = 'https://stats.nba.com/media/img/teams/logos';
export const DEFAULT_PLAYER_INFO = {
    playerId: 201939,
    playerName: 'Stephen Curry',
    teamAbbreviation: 'GSW',
};